module.exports = __webpack_public_path__ + "static/media/background-1.6aa675c5.jpg";